<template>
  <div id="app">
    <div class="content">
      <router-view />
    </div>
  </div>
</template>

<script>
import 'normalize.css';
import './assets/css/style.scss';

export default {
  name: 'App',
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100%;
}

.content {
  width: 100%;
  height: 100%;
}
</style>
